// import { productRows } from "../../dummyData";
// import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import alasql from "alasql";
//import Chart from '../../components/chart/Chart'
import {
  // AreaChart,
  // Area,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import { DataGrid } from "@material-ui/data-grid";

import "./yields.css";
// import { DeleteOutline } from "@material-ui/icons";
import { apiYieldsUrl } from "../../config";

import { FilterBlockchain } from "../../components/filters/Blockchain";
import { MostAdvancedTable } from "../../components/reactTable/MostAdvancedTable";
import {
  tblColumns,
  statsColumns,
} from "../../components/reactTable/columnsYields";
import SetTitle from "../../components/setTitle/SetTitle";
import IntervalsMenu from "../../components/intervalsMenu/IntervalsMenu";
import { walletShort } from "../../components/common/dataShort";

//const apiYieldsUrl = "http://93.190.43.170:4000/api/yields/";

export default function Yields({dateRange,setDateRange}) {
  SetTitle("Yields of Vaults");

  const ALLOW_NON_ZERO_HOURS = 1;

  const [defiData, setDefiData] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const [statsData, setStatsData] = useState([]);
  const [vaults, setVaults] = useState([]);
  // const [dateRange, setDateRange] = useState("1M");

  useEffect(() => {
    const getDefiData = async () => {
      try {
        console.log(apiYieldsUrl + dateRange);
        const res = await axios.get(apiYieldsUrl + dateRange, {
          /*headers: {
            token:
            "Bearer "+JSON.parse(localStorage.getItem("user")).accessToken,
          },*/
        });
        let vaultByAssetId = [];
        let dataByAssetId = [];
        let dataByDt = [];

        let dataShort = res.data.map((item) => {
          item.Wallet = walletShort(item.Wallet);
            // item.Wallet.substr(0, 4) +
            // "..." +
            // item.Wallet.substr(item.Wallet.length - 4);

          if (typeof dataByAssetId[item.assetId] === "undefined")
            dataByAssetId[item.assetId] = [];
          dataByAssetId[item.assetId].push({
            Datetime: item.Datetime,
            Balance: item.Balance,
            Reward: item.Reward,
            RewardToken: item.RewardToken,
          });

          let dt = new Date(item.Datetime);
          let hours = dt.getHours();
          if (hours == 0 || ALLOW_NON_ZERO_HOURS) {
            dt.setSeconds(0); //может быть разброс в несколько секунд от 02 до 04, сводим это все в 0, ошибка на 3 часах: 3*60*60=10800; 1/10800 ~ 0.01%
            // dt: Sun Jun 19 2022 20:53:00 GMT+0300 (Eastern European Summer Time) -> dtStr: 2022-Jun-19 20:53:00
            var dtStr = dt
              .toString()
              .replace(
                /^[^\s]+\s([^\s]+)\s([^\s]+)\s([^\s]+)\s([^\s]+)\s.*$/gi,
                "$3-$1-$2 $4"
              );
            // console.log(dt, dtStr);
            if (typeof dataByDt[dtStr] === "undefined") {
              dataByDt[dtStr] = [];
              dataByDt[dtStr].push({ Dt: dtStr, Datetime: item.Datetime });
            }
            dataByDt[dtStr][item.assetId] = {
              Balance: item.Balance,
              Reward: item.Reward,
              RewardToken: item.RewardToken,
            };
          }

          return item;
          //console.log(item.Wallet)
        });

        console.log("dataShort =", dataShort);
        console.log("dataByDt =", dataByDt);

        /*console.log(
          dataByAssetId,
          dataByDt,
          typeof dataByDt,
          Object.values(dataByDt)
        );*/

        //console.log('defiData=', res.data);

        // Складывает как строки (а не числа):
        //SUM(Balance) AS sumBal,
        //SUM(Reward) AS sumRwd,
        let stats = alasql(
          "SELECT assetId, COUNT(*) AS cnt, min(Datetime) AS minDt, max(Datetime) AS maxDt, \
              max(Balance) AS maxBal, min(Balance) AS minBal, \
              max(Reward) AS maxRwd, min(Reward) AS minRwd, \
              max(Wallet) AS Wallet, max(Blockchain) AS Blockchain, max(Platform) AS Platform, max(Vault) AS Vault \
              FROM ? WHERE Balance<>0 GROUP BY assetId",
          [dataShort]
        );
        //var d = [ {a: 1, b: 10}, {a: 2, b: 20}, {a: 1, b: 30} ];
        //var r = alasql('SELECT a, SUM(b) AS b FROM ? GROUP BY a',[d]);
        stats = AddId(stats);
        stats = AddStats(stats);
        console.log("Yields =", stats);
        /*stats = [
          { id: 0, assetId: stats[0]["assetId"], balApr: stats[0]["balApr"] },
        ];
        console.log("Test yields =", stats);*/

        let vaultsL = alasql(
          "SELECT DISTINCT assetId, Wallet, Blockchain, Platform, Vault FROM ?",
          [dataShort]
        );
        //console.log("vaultsL=", vaultsL);

        setDefiData(dataShort); //res.data
        setGraphData(Object.values(dataByDt));
        setStatsData(stats);
        setVaults(vaultsL);
      } catch (err) {
        console.log(err);
      }
    };
    getDefiData();
  }, [dateRange]);

  const AddId = (data) => {
    let i = 0;
    let r = data.map((row) => {
      return { id: i++, ...row };
    });
    return r;
  };

  function DaysBetween(date1, date2) {
    // The number of milliseconds in one day
    const oneDay = 1000 * 60 * 60 * 24;

    // Calculate the difference in milliseconds
    const differenceMs = Math.abs(date1 - date2);
    //console.log(date1, date2, differenceMs)

    // Convert back to days and return
    let r = differenceMs / oneDay;
    return +r.toFixed(2);
  }

  const AddStats = (data) => {
    let i = 0;
    let r = data.map((row) => {
      let daysBetw = DaysBetween(new Date(row.maxDt), new Date(row.minDt));

      // balOfMaxDt, т.е. баланс последней даты м.б.!= maxBal, т.е. максимальному балансу
      let balOfMaxDt = defiData.filter((v) => {
        // if (v.assetId == 401)
        // if(v.assetId == row.assetId)
        if (v.Datetime == row.maxDt)
          console.log("flt =", v.assetId, row.assetId, v.Datetime, row.maxDt);
        return v.assetId == row.assetId && v.Datetime == row.maxDt;
      });
      console.log("balOfMaxDt =", balOfMaxDt.Balance);

      return {
        daysBetween: daysBetw,
        balDelta: row.maxBal - row.minBal,
        balGrowth: row.maxBal / row.minBal,
        balAprDaily: ((row.maxBal / row.minBal - 1) / daysBetw) * 100,
        balApr: ((row.maxBal / row.minBal - 1) / daysBetw) * 100 * 365,
        rwdDelta: row.maxRwd - row.minRwd,
        rwdGrowth: row.minRwd != 0 ? row.maxRwd / row.minRwd : 0,
        rwdAprDaily:
          row.minRwd != 0
            ? ((row.maxRwd / row.minRwd - 1) / daysBetw) * 100
            : 0,
        rwdApr:
          row.minRwd != 0
            ? ((row.maxRwd / row.minRwd - 1) / daysBetw) * 100 * 365
            : 0,
        ...row,
      };
    });
    return r;
  };

  const handleDelete = (id) => {
    //setData(data.filter((item) => item.id !== id));
  };

  var getName = (x) => {
    return x[0]["Dt"];
  };
  var getVal1 = (x) => {
    return typeof x[1] === "undefined" ? 0 : x[1]["Balance"];
  };
  var getVal2 = (x) => {
    return typeof x[2] === "undefined" ? 0 : x[2]["Balance"];
  };
  var getVal3 = (x) => {
    return typeof x[3] === "undefined" ? 0 : x[3]["Balance"];
  };
  var getVal4 = (x) => {
    return typeof x[4] === "undefined" ? 0 : x[4]["Balance"];
  };
  var getVal5 = (x) => {
    return typeof x[5] === "undefined" ? 0 : x[5]["Balance"];
  };
  var getVal6 = (x) => {
    return typeof x[6] === "undefined" ? 0 : x[6]["Balance"];
  };
  var getVal7 = (x) => {
    return typeof x[7] === "undefined" ? 0 : x[7]["Balance"];
  };
  var getVal8 = (x) => {
    return typeof x[8] === "undefined" ? 0 : x[8]["Balance"];
  };
  var getVal9 = (x) => {
    return typeof x[9] === "undefined" ? 0 : x[9]["Balance"];
  };
  var getVal10 = (x) => {
    return typeof x[10] === "undefined" ? 0 : x[10]["Balance"];
  };
  //console.log('gD:', graphData)

  // console.log(graphData, getName, getVal1);
  console.log(statsData, vaults);
  return (
    <div className="yields">
      <h1>Yields</h1>
      {/*graphData['2021-Sep-18 06:28:00'][0]['Dt']*/}
      {/*<Chart data={userData} title="User Analytics" grid dataKey="Active User"/>*/}
      {/*<FilterBlockchain supportedTokens={supportedTokens} />*/}
      <IntervalsMenu dateRange={dateRange} setDateRange={setDateRange} />

      <ResponsiveContainer width="100%" height={500}>
        <LineChart data={graphData}>
          <XAxis dataKey={getName} stroke="#5550bd" />
          <YAxis stroke="#5550bd" />
          <Line type="monotone" dataKey={getVal1} stroke="#5550bd" />
          <Line type="monotone" dataKey={getVal2} stroke="yellow" />
          <Line type="monotone" dataKey={getVal3} stroke="violet" />
          <Line type="monotone" dataKey={getVal4} stroke="silver" />
          <Line type="monotone" dataKey={getVal5} stroke="brown" />
          <Line type="monotone" dataKey={getVal6} stroke="green" />
          <Line type="monotone" dataKey={getVal7} stroke="grey" />
          <Line type="monotone" dataKey={getVal8} stroke="red" />
          <Line type="monotone" dataKey={getVal9} stroke="blue" />
          <Line type="monotone" dataKey={getVal10} stroke="orange" />
          <Tooltip />
          <Legend />
          <CartesianGrid stroke="#e0dfdf" strokeDasharray="5 5" />
        </LineChart>
      </ResponsiveContainer>

      {/* <br />
      <br />
      <MostAdvancedTable propData={statsData} tblColumns={tblColumns} />
       */}
      <br />
      <br />
      <DataGrid
        rows={statsData}
        columns={statsColumns(vaults)}
        pageSize={50}
        checkboxSelection
        disableSelectionOnClick
        autoHeight
      />
    </div>
  );
}

/*const statsDataTest = [
    {
      Blockchain: "BSC",
      Platform: "Autofarm",
      Vault: "BUSD-WINGS LP",
      Wallet: "0x68...4ff6",
      assetId: "2",
      balApr: 123.56685655824258,
      balAprDaily: 0.33853933303628103,
      balDelta: 0.8041115402486012,
      balGrowth: 1.2188656788079557,
      cnt: 585,
      daysBetween: 64.65,
      id: 1,
    },
    {
      Blockchain: "Polygon",
      Platform: "Autofarm",
      Vault: "DAI-USDC-USDT LP (aave) | Curve",
      Wallet: "0xAf...135F",
      assetId: "3",
      balApr: "2.907851350437408e23",
      balAprDaily: "796671602859563800000",
      balDelta: 515.0481912487081,
      balGrowth: "515048191248708100000",
      cnt: 585,
      daysBetween: 64.65,
      id: 2,
    },
  ];
  const statsDataTest = [];
  statsDataTest.push(statsData[0]);
  statsDataTest.push(statsData[1]);
  console.log(statsDataTest);
  */

// const statsDataTest = [
//   {
//     balApr: 6.300094796609157,
//     id: 0,
//     assetId: "1",
//   },
// ];
